<script lang="ts" module>
  export enum VARIANT {
    SUCCESS,
    ERROR,
  }
</script>

<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"
  import type { FlyParams } from "svelte/transition"
  import { fly } from "../transition"
  import Layer1 from "./backlight-layer1.svg?icon"
  import Layer2 from "./backlight-layer2.svg?icon"

  let {
    variant = VARIANT.SUCCESS,
    ...props
  }: { variant?: VARIANT } & HTMLAttributes<HTMLDivElement> = $props()

  const LAYERS_CLASSES_BY_VARIANT = {
    [VARIANT.SUCCESS]: ["text-[#B5FF6A]", "text-[#EFFF32]"].map(
      (c) => `status-backlight-success ${c}`, // external customization class
    ),
    [VARIANT.ERROR]: ["text-[#FF5B8D]", "text-[#FF5A43] translate-y-2"].map(
      (c) => `status-backlight-error ${c}`, // external customization class
    ),
  }

  const transition = (params: FlyParams) => (node: Element) => fly(node, params)
</script>

<div {...props} class={`status-backlight relative size-full ${props.class ?? ""}`}>
  <Layer1
    class={`status-backlight-layer ${LAYERS_CLASSES_BY_VARIANT[variant][0]} aspect-[390/318]`}
    transition={transition({ duration: 500, y: "50%" })}
  />
  <Layer2
    class={`status-backlight-layer ${LAYERS_CLASSES_BY_VARIANT[variant][1]} aspect-[390/90]`}
    transition={transition({ duration: 500, y: "50%", delay: 150 })}
  />
</div>

<style lang="postcss">
  .status-backlight :global(.status-backlight-layer) {
    @apply absolute bottom-0 left-0 h-auto w-full transition-[opacity,color] duration-500;

    mask-position: bottom;
  }
</style>
